
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import Link from 'components/Link'
import Icon from 'components/Icon'

export default class Breadcrumbs extends React.Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      path: PropTypes.string
    }))
  }

  render() {
    const {items} = this.props

    if (items && items.length) {
      return (
        <div className='breadcrumbs'>
          {items.map(this.renderItem)}
        </div>
      )
    } else {
      return null
    }
  }

  renderItem(item, index) {
    const isFirst = (index === 0)
    const icon = isFirst && <Icon className='breadcrumbs_back-icon' name='chevron' size='8px' />
    return (
      <span key={index}>
        {isFirst ? null : <span className='breadcrumbs_divider'>/</span>}
        <Link
          to={item.path}
          className='breadcrumbs_item'>{icon}{item.title}</Link>
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Breadcrumbs/index.js